import { axiosInstance } from '../../api';
const BASE_PATH = '/manage_users';

//Add New User API Call
export let addNewUser = async (email, userRole) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_user', {
            email: email.trim(),
            userRole: userRole,
        })
        return value;
    } catch (error) {
        return error
    }
}

//Get All Users Details API Call
export let getAllUsers = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_users')
        return value
    } catch (error) {
        return error
    }
}

//Update User API Call
export let updateUser = async (userID, userRole) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_user_permissions', {
            user_id: userID,
            userRole: userRole,
        })
        return value;
    } catch (error) {
        return error
    }
}

//Delete User API Call
export let deleteUser = async (userID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/remove_user', {
            user_id: userID
        })
        return value;
    } catch (error) {
        return error
    }
}

//Get All CV Reviewers API Call
export let getAllReviewers = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_all_reviewers')
        return value
    } catch (error) {
        return error
    }
}
